import { h } from 'preact';
import { isBaseRegion, isFocusStudio } from 'utils/studioConfig';

import UniversalMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversal';
import UniversalBaseMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversalBase';
import FocusMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaFocus';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieMediaEditor {...props} />;
	if (isBaseRegion()) return <UniversalBaseMovieMediaEditor {...props} />;
	return <UniversalMovieMediaEditor {...props} />;
};
